import { TextAreaAi, useSocket, useTextChat } from '@mint-lib/ai-chat';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { useAiSidebarContext } from '../../../context.jsx';
import SidebarHeader from '../../molecules/SidebarHeader/SidebarHeader.jsx';
import SuggestionOriginDetails from '../../molecules/SuggestionOriginDetails/SuggestionOriginDetails.jsx';
import { ChatConversation } from '../ChatConversation/ChatConversation.jsx';

type AiContentProps = {
  isWithSidebar?: boolean;
};

const AiContent = ({ isWithSidebar = true }: AiContentProps) => {
  const { chatId } = useSocket();
  const {
    chatMessages,
    reasoningMessages,
    isAiProcessing,
    sendMessage,
    isChatHistoryLoading,
  } = useTextChat();

  const { selectedSuggestion } = useAiSidebarContext();

  const handleSendMessage = (text: string) => {
    if (!selectedSuggestion) {
      return;
    }

    const messageMetadata: Chat.UserMetadataSchemaType = {
      reco: {
        recoId: selectedSuggestion.id,
      },
    };

    sendMessage({ text: text.trim(), metadata: messageMetadata });
  };

  return (
    <div className="flex h-full [scrollbar-width:none] flex-col justify-between overflow-y-auto">
      <div>
        <SidebarHeader isWithSidebar={isWithSidebar} />
        <SuggestionOriginDetails />
        <div className="mt-3">
          <ChatConversation
            chatId={chatId}
            chatMessages={chatMessages}
            reasoningMessages={reasoningMessages}
            isAiProcessing={isAiProcessing}
            isLoading={isChatHistoryLoading}
          />
        </div>
      </div>
      <div className="sticky bottom-0 w-full bg-ui-primary pb-2">
        <TextAreaAi handleSendQuestion={handleSendMessage} />
      </div>
    </div>
  );
};
export default AiContent;
